import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { OfficialProblemCategory } from '@/domain/entities/problem/officialProblemCategory'
import { ProblemAttachment } from '@/domain/entities/problem/problemAttachment'
import { ProblemStatistics } from '@/domain/entities/problem/problemStatistics'
import { ProblemStatisticsModuleName } from '@/store/modules/modules'

export class ProblemStatisticsViewModel {
  private store = useStore()

  problemAttachment: ComputedRef<ProblemAttachment> = computed(
    () => this.store.getters[`${ProblemStatisticsModuleName}/problemAttachment`]
  )

  problemStatistics: ComputedRef<ProblemStatistics> = computed(
    () => this.store.getters[`${ProblemStatisticsModuleName}/problemStatistics`]
  )

  officialProblemCategoryList: ComputedRef<OfficialProblemCategory[]> = computed(
    () => this.store.getters[`${ProblemStatisticsModuleName}/officialProblemCategoryList`]
  )

  isLoading: ComputedRef<boolean> = computed(() => this.store.getters[`${ProblemStatisticsModuleName}/isLoading`])

  error: ComputedRef<string | null> = computed(() => this.store.getters[`${ProblemStatisticsModuleName}/error`])

  async getProblemStatistics(problemId: string): Promise<void> {
    await this.store.dispatch(`${ProblemStatisticsModuleName}/getProblemStatistics`, { problemId })
  }

  async getOfficialProblemCategory(): Promise<void> {
    await this.store.dispatch(`${ProblemStatisticsModuleName}/getOfficialProblemCategory`)
  }
}
